import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_FineTypeSetup } from "../shared/data.service";
import { FineTypeInsertRequest } from "../shared/FineTypeInsertRequest";
import { FineTypeInUseRequest } from "../shared/FineTypeInUseRequest";

@Component({
	selector: "app-admin-setup-add-fine-type",
	templateUrl: "./admin-setup-add-fine-type.component.html",
	styleUrls: ["./admin-setup-add-fine-type.component.css"],
})
export class AdminSetupAddFineTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private FineTypeSetupService: DataService_FineTypeSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.DefinedBy = this.user.UserLevelID == 3 ? "School User" : "District User";
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	user: any;
	SchoolID: any;

	//Form
	FineCD: any = "";
	FineDesc: any = "";
	DefinedBy: any = "User";
	FineAmount: any = 0.0;

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onAdd() {
		if (this.FineCD == "") {
			this.errorMessage = "Enter a code";
			return;
		} else if (this.FineDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		} else {
			this.CheckCD();
		}
	}

	CheckCD() {
		let parms: FineTypeInUseRequest = {
			str: this.FineCD,
			SchoolID: this.SchoolID,
		};

		var result = this.FineTypeSetupService.FineTypeCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Fine Type Code/Abbreviation Already in Use";
					return;
				} else {
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: FineTypeInUseRequest = {
			str: this.FineDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.FineTypeSetupService.FineTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Fine Type Name/Description Already in Use";
					return;
				} else {
					this.FinishAdd();
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		var DFB = this.user.UserLevelID == 3 ? 3 : 4;

		let parms: FineTypeInsertRequest = {
			AccountDebitTypeCD: this.FineCD,
			AccountDebitTypeDesc: this.FineDesc,
			AccountDebitDefaultAmount: this.FineAmount,
			DefinedByID: DFB,
			SchoolID: this.SchoolID,
		};

		var result = this.FineTypeSetupService.FineTypeInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fine Type was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Fine Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
